@use '@/sass/variables';

.circularProgress {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  line-height: 0;
}

.trail {
  stroke: variables.$moon-gray;
  fill: none;
}

.path {
  fill: none;
  stroke-linecap: round;
  transform: rotate(-90deg);
  transform-origin: center;
  transition: stroke-dashoffset 0.3s ease;

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
}

.pathActive {
  stroke: variables.$blue;
}

.pathSuccess {
  stroke: variables.$green;
}

.pathError {
  stroke: variables.$red;
}

.symbol {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: variables.$near-black;
  font-weight: 400;
  line-height: 1;
  pointer-events: none;
}

.symbolSuccess {
  color: variables.$green;
}

.symbolError {
  color: variables.$red;
}
